// extracted by mini-css-extract-plugin
export var active = "_78-c";
export var activeIndicator = "_78-7";
export var animate = "_78-b";
export var contentWidthTabs = "_78-5";
export var disabled = "_78-d";
export var flat = "_78-1";
export var fullWidth = "_78-3";
export var lg = "_78-a";
export var md = "_78-9";
export var redoButtonTabGroup = "_78-0";
export var sm = "_78-8";
export var tabButton = "_78-4";
export var tabButtonsContainer = "_78-2";
export var xs = "_78-6";